var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.replace.js
// module id = 430
// module chunks = 0